// extracted by mini-css-extract-plugin
export default {"color-tile":"KLFCWLf","color-tile--disabled":"yN8p3DD","color-tile--selected":"M5xIEwI","color-tile--tooltip":"vDmSdVv"};